const languagesMapOld = {
  EN: 'English ',
  AF: 'Afrikaans',
  AR: 'العربية / Arabic',
  AZ: 'Azərbaycan dili / Azerbaijani',
  BG: 'Български / Bulgarian',
  CH: '中文(简体) / Chinese (Simplified)',
  'CH-PRC': '中文(简体) / Chinese (Simplified)',
  CHTR: '中文(繁體) / Chinese (Traditional)',
  CHHK: '中文(香港) / Chinese(Traditional) HK',
  CZ: 'Češki / Czech',
  DE: 'Deutsch / German',
  DK: 'Dansk / Danish',
  DU: 'Nederlands / Dutch',
  ES: 'Español / Spanish (Castellano)',
  'ES-LATAM': 'Español / Spanish (Latam)',
  FL: 'Tagalog / Filipino',
  FR: 'Français / French',
  GR: 'ελληνικά / Greek',
  HE: 'עִבְרִית / Hebrew',
  HI: 'हिन्दी/ Hindi',
  IN: 'Bahasa Indonesia / Indonesian',
  IT: 'Italiano / Italian',
  JP: '日本語 / Japanese',
  KO: '한국어 / Korean',
  MK: 'Македонски / Macedonian',
  MY: 'Melayu / Malay',
  NO: 'Norsk / Norwegian',
  PL: 'Polski / Polish',
  PT: 'Português / Portuguese',
  'PT-BR': 'Português Brasileiro / Portuguese Brazil',
  RO: 'Rumunski / Romanian',
  RU: 'Pусский / Russian',
  SR: 'Cрпски / Serbian',
  TH: 'ภาษาไทย / Thai',
  THAI: 'ภาษาไทย / Thai',
  TR: 'Türkçe / Turkish',
  UA: 'Yкраїнська / Ukrainian',
  UR: 'اردو / Urdu',
  VN: 'Tiếng Việt / Vietnamese',
  ENUS: 'English(United States)',
  BS: 'Bosanski / Bosnian',
  ME: 'Crnogorski / Montenegrian',
  HU: 'Mađarski / Hungarian',
  HR: 'Hrvatski / Croatian',
  MN: 'Mongolian / Mongolian',
  SL: 'Slovenački / Slovenian',
  SQ: 'Shqip / Albanian',
};

const languagesMap = {
  EN: 'English',
  AF: 'Afrikaans / Afrikaans',
  AR: 'Arabic / العربية',
  AZ: 'Azerbaijani / Azərbaycan dili',
  BG: 'Bulgarian / Български',
  CH: 'Chinese (Simplified) / 中文(简体)',
  'CH-PRC': 'Chinese (Simplified) / 中文(简体)',
  CHTR: 'Chinese (Traditional) / 中文(繁體)',
  CHHK: 'Chinese (Traditional, HK) / 中文(香港)',
  CZ: 'Czech / Češki',
  DE: 'German / Deutsch',
  DK: 'Danish / Dansk',
  DU: 'Dutch / Nederlands',
  ES: 'Spanish (Castilian) / Español',
  'ES-LATAM': 'Spanish (Latam) / Español',
  FL: 'Filipino / Tagalog',
  FR: 'French / Français',
  GR: 'Greek / Ελληνικά',
  HE: 'Hebrew / עִבְרִית',
  HI: 'Hindi / हिन्दी',
  IN: 'Indonesian / Bahasa Indonesia',
  IT: 'Italian / Italiano',
  JP: 'Japanese / 日本語',
  KO: 'Korean / 한국어',
  MK: 'Macedonian / Македонски',
  MY: 'Malay / Melayu',
  NO: 'Norwegian / Norsk',
  PL: 'Polish / Polski',
  PT: 'Portuguese / Português',
  'PT-BR': 'Portuguese (Brazil) / Português Brasileiro',
  RO: 'Romanian / Rumunski',
  RU: 'Russian / Русский',
  SR: 'Serbian / Српски',
  TH: 'Thai / ภาษาไทย',
  THAI: 'Thai / ภาษาไทย',
  TR: 'Turkish / Türkçe',
  UA: 'Ukrainian / Українська',
  UR: 'Urdu / اردو',
  VN: 'Vietnamese / Tiếng Việt',
  ENUS: 'English (United States)',
  BS: 'Bosnian / Bosanski',
  ME: 'Montenegrin / Crnogorski',
  HU: 'Hungarian / Mađarski',
  HR: 'Croatian / Hrvatski',
  MN: 'Mongolian / Монгол хэл',
  SL: 'Slovenian / Slovenački',
  SQ: 'Albanian / Shqip',
};

export default languagesMap;
